import { render, staticRenderFns } from "./1347_制造字母异位词的最小步骤数.md?vue&type=template&id=81edc79a&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports